import Button from '@atoms/Button/Button';
import Icon from '@atoms/Icon/Icon';
import { ICard } from '@models/ICard';
import updateDataLayer from '@utils/helpers/gtm';

const Card = ({ icon, title, text, link, carouselTitle = '' }: ICard) => (
  <div className="z-10 mx-px mb-px flex h-full flex-col items-start overflow-hidden rounded-md border border-grey p-7 md:rounded-[10px]">
    {icon && (
      <Icon name={icon} className="mb-7 text-black-100 dark:text-white" />
    )}
    {title && (
      <p className="h5 mb-3" data-testid="CT-59-Card-Carousel-Card-Title">
        {title}
      </p>
    )}

    {text && (
      <div
        dangerouslySetInnerHTML={{ __html: text }}
        className="body-two mb-10 max-w-[364px] text-grey-450 content-area dark:text-grey-500"
        data-testid="CT-59-Card-Carousel-Card-Text"
      />
    )}
    {link?.name && link?.url && (
      <Button
        link={link}
        linkCallback={() =>
          updateDataLayer({
            event: 'selectContent',
            content_type: carouselTitle,
            link_text: title,
          })
        }
        className="mt-auto"
        dataTestId="CT-59-Card-Carousel-Card-Link"
      >
        {link.name}
      </Button>
    )}
  </div>
);

export default Card;
